import { createSelector, createSlice } from '@reduxjs/toolkit';

const certificateSlice = createSlice({
    initialState: {
        certificates: [],
        certificateTypes: [], // NEW: Certificate types
        totalRecords: 0,
        isLoading: false,
        isLoadingTypes: false, // NEW: Loading state for types
        currentPage: 0,
        filters: [],
    },
    name: 'certificates',
    reducers: {
        fetchCertificates: state => {
            state.certificates = [];
            state.isLoading = true;
        },
        certificatesFetched: (state, { payload }) => {
            const { results, totalRecords } = payload;
            state.certificates = results;
            state.totalRecords = totalRecords;
            state.isLoading = false;
        },
        certificatesFetchRequestFailed: state => {
            state.isLoading = false;
        },
        resetCertificates: state => {
            state.certificates = [];
        },
        // NEW: Certificate types actions
        fetchCertificateTypes: state => {
            state.isLoadingTypes = true;
        },
        certificateTypesFetched: (state, { payload }) => {
            state.certificateTypes = payload;
            state.isLoadingTypes = false;
        },
        certificateTypesFetchRequestFailed: state => {
            state.isLoadingTypes = false;
        },
        upsertFilter: (state, { payload }) => {
            const { key, value } = payload;
            const index = state.filters.findIndex(f => f.key === key);

            // If no filter exist and value is also nothing then return
            if (index === -1 && value === '') {
                return;
            }

            if (index === -1) {
                state.filters.push(payload);
            } else {
                state.filters[index].value = value;
            }
        },
        removeFilter: (state, { payload }) => {
            const index = state.filters.findIndex(f => f.key === payload);

            if (index !== -1) {
                state.filters.splice(index, 1);
            }
        },
        removeAllFilters: state => {
            state.filters = [];
        },
    },
});

// selectors

const getSelf = state => state.certificates;
export const getCertificates = createSelector(
    getSelf,
    state => state.certificates,
);

// NEW: Certificate types selector
export const getCertificateTypes = createSelector(
    getSelf,
    state => state.certificateTypes,
);

export const getFilters = createSelector(getSelf, state => state.filters);

export const isLoading = createSelector(getSelf, state => state.isLoading);

// NEW: Loading state for types
export const isLoadingTypes = createSelector(
    getSelf,
    state => state.isLoadingTypes,
);

export const getTotalRecords = createSelector(
    getSelf,
    state => state.totalRecords,
);

export const {
    fetchCertificates,
    certificatesFetched,
    certificatesFetchRequestFailed,
    resetCertificates,
    // NEW: Certificate types exports
    fetchCertificateTypes,
    certificateTypesFetched,
    certificateTypesFetchRequestFailed,
    // Filters
    upsertFilter,
    removeFilter,
    removeAllFilters,
} = certificateSlice.actions;

export default certificateSlice.reducer;
